import React, { useState } from "react";
import styles from "./Navbar.module.css";
import { Link } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLanguage } from "../i18n/LanguageContext";




function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useLanguage();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className={styles.navbar}>
      <a href="/" className={styles.logo}>
        Valmis
      </a>
      <span className={styles.menuToggle} onClick={toggleMenu}>
        &#9776; {/* Иконка меню */}
      </span>
      <div className={`${styles.navLinks} ${menuOpen ? styles.active : ""}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}> {t("common.home")}</Link>
        <Link to="/about-brand" onClick={() => setMenuOpen(false)}> {t("common.aboutBrand")}</Link> {/* Updated link */}
        {/* <Link to="/about" onClick={() => setMenuOpen(false)}>О компании</Link> */}
        {/* <Link to="/products" onClick={() => setMenuOpen(false)}>Products</Link> */}
        <Link to="/contact-us" onClick={() => setMenuOpen(false)}> {t("common.contactUs")}</Link>
         {/* 🔤 Language Switcher */}
       <LanguageSwitcher />
      </div>
     
    </nav>
  );
}

export default Navbar;
